import { C, CLS_RANK } from "./constants";

export function extractJSON(text) {
  const m = text.match(/```(?:json)?\s*([\s\S]*?)```/) || text.match(/(\[[\s\S]*\]|\{[\s\S]*\})/);
  return m ? (m[1] || m[0]).trim() : text.trim();
}

export const dirColor = d => d === "up" ? C.up : d === "down" ? C.down : C.neut;
export const dirLabel = d => d === "up" ? "확전 요인" : d === "down" ? "진정 요인" : "중립";

export const splitBullets = v => Array.isArray(v) ? v : v.split(/(?<=다|음|요)\.\s+/).filter(s => s.trim().length > 3);

export const byImportance = arr => [...arr].sort((a, b) => (CLS_RANK[a.cls] ?? 3) - (CLS_RANK[b.cls] ?? 3));

// Returns true iff the string contains at least one Korean syllable/jamo.
// Used to fall back from untranslated hed_ko (English echo) to original hed.
export const hasKorean = s => /[\u3131-\uD79D\uAC00-\uD7A3]/.test(s || "");
export const pickKoreanTitle = (hed_ko, hed) => hasKorean(hed_ko) ? hed_ko : hed;

// RSS summary 정리: 옛 캐시 항목이 entity-인코딩된 HTML 노이즈를 가진 경우 클라이언트에서 한 번 더 정리.
// 워커가 cleanRssText로 처리한 새 데이터는 이미 깨끗하지만 방어적으로 적용.
const _ENT = { "&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'","&apos;":"'","&nbsp;":" ","&ndash;":"–","&mdash;":"—","&hellip;":"…","&ldquo;":'"',"&rdquo;":'"',"&lsquo;":"'","&rsquo;":"'" };
export function cleanText(raw) {
  if (!raw) return "";
  let s = String(raw);
  s = s.replace(/&(?:amp|lt|gt|quot|#39|apos|nbsp|ndash|mdash|hellip|ldquo|rdquo|lsquo|rsquo);/gi, m => _ENT[m.toLowerCase()] || m);
  s = s.replace(/&#(\d+);/g, (_, n) => String.fromCharCode(parseInt(n, 10)));
  s = s.replace(/&#x([0-9a-f]+);/gi, (_, n) => String.fromCharCode(parseInt(n, 16)));
  s = s.replace(/<[^>]*>/g, " ");
  s = s.replace(/&[a-z#0-9]+;/gi, " ").replace(/\s+/g, " ").trim();
  return s;
}

// 카드 폴백용: 첫 한 문장만 (220자 컷)
export function firstSentence(raw) {
  const s = cleanText(raw);
  if (!s) return "";
  const m = s.match(/^[^.!?]+[.!?]/);
  const first = m ? m[0] : s;
  return first.length > 220 ? first.slice(0, 217) + "…" : first;
}

export function relativeTime(input) {
  if (!input) return "";
  const t = typeof input === "string" ? new Date(input).getTime() : new Date(input).getTime();
  if (isNaN(t)) return typeof input === "string" ? input : "";
  const diff = Math.floor((Date.now() - t) / 1000);
  if (diff < 0) return "방금 전";
  if (diff < 60) return "방금 전";
  if (diff < 3600) return `${Math.floor(diff / 60)}분 전`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}시간 전`;
  return `${Math.floor(diff / 86400)}일 전`;
}
